import React from 'react';
import { supabase } from '../lib/supabaseClient';

type UseInvoiceDocumentsLiveOptions = {
  instanceId: string | null;
  onRefresh: () => void;
};

export function useInvoiceDocumentsLive({ instanceId, onRefresh }: UseInvoiceDocumentsLiveOptions) {
  const onRefreshRef = React.useRef(onRefresh);
  onRefreshRef.current = onRefresh;

  React.useEffect(() => {
    if (!instanceId) return;

    let debounceTimer: ReturnType<typeof setTimeout> | null = null;
    const scheduleRefresh = () => {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        onRefreshRef.current();
      }, 600);
    };

    const changeConfig = {
      schema: 'public' as const,
      table: 'invoice_documents' as const,
      filter: `instance_id=eq.${instanceId}`,
    };

    const channel = supabase
      .channel(`invoice_documents:${instanceId}`)
      .on('postgres_changes', { event: 'INSERT', ...changeConfig }, scheduleRefresh)
      .on('postgres_changes', { event: 'UPDATE', ...changeConfig }, scheduleRefresh)
      .on('postgres_changes', { event: 'DELETE', ...changeConfig }, scheduleRefresh)
      .subscribe();

    return () => {
      if (debounceTimer) clearTimeout(debounceTimer);
      void supabase.removeChannel(channel);
    };
  }, [instanceId]);
}
